class Circles {
	constructor(nav) {
		this.nav = nav;
		this.circles = [];
		
		this._newDialog = null;
		this._newTypeForm = null;
		this._newType = null;
		this._newUserDetails = null;
		this._newMembersForm = null;
		this._newMembersList = [];
		this._newCircleProtected = null;
		
		this._route = [];
		this._plan = null;
	}

	get newDialog() {
		if (this._newDialog == null) {
			this._newDialog = Dialog.Modal('supervision', _('New Circle'), LARGE, 'NEXT');
			this._newDialog.onAffirm = this.next.bind(this);
			this._newDialog.autoClose = false;
			this._newDialog.foot = this.newCircleBackBtn = UI.btn('btn', _('BACK'), {
				'click': this.back.bind(this)
			});
			API.fetch('plans')
			.then(reply => this._plan = reply);
			this._newDialog.affirmButton.disabled = true;
		}

		return this._newDialog;
	}

	get newTypeForm() {
		if (this._newTypeForm == null) {
			this._newTypeForm = UI.div(
				'p-5',
				[
					UI.htm('h2', 'text-xl', 'Who is the new circle for?'),
					UI.p('', _('Circles center around an individual who is being supported by the other members of the circle.')),
					UI.p('', _('Who will be at the center of this new circle?')),
					UI.form([
						this._newRadio1,
						UI.label([
							this._newRadio1 = UI.input(
								'radio',
								'm-3',
								1,
								{ 'change': this.setNewType.bind(this) },
								{ 'name': 'new-member-type' }
							),
							UI.span('', _('ME')),
						]),
						UI.label([
							this._newRadio2 = UI.input(
								'radio',
								'm-3',
								2,
								{ 'change': this.setNewType.bind(this) },
								{ 'name': 'new-member-type' }
							),
							UI.span('', _('SOMEONE ELSE'))
						])
					])
				]
			);
		}
		else {
			// this._newRadio1.checked = false;
			// this._newRadio2.checked = false;
		}
		this.setNewType();
		return this._newTypeForm;
	}

	get newUserDetails() {
		if (this._newUserDetails == null) {
			this._newUserPermission = new Permissions(null, Nav.CIRCLE);
			
			this._newUserDetails = UI.form([
				UI.formRow([
					UI.label(_('Their first and last name')),
					this._fullName = UI.text(null, null, {
						'aria-label': 'First and last name',
						'data-tip': 'above',
						'data-validate': 'required name'
					})
				]),
				UI.formRow([
					UI.label(_('Username')),
					this._username = UI.text(null, null, {
						'aria-label': 'Username',
						'placeholder': _('Optional if email address entered'),
						'data-validate': 'reqWithoutEmail uniqueUsername'
					})
				]),
				UI.formRow([
					UI.label(_('Email address')),
					this._email = UI.text(null, null, {
						'aria-label': 'Email address',
						'placeholder': _('Optional if username entered'),
						'data-validate': 'reqWithoutUsername uniqueEmail'
					})
				]),
				UI.formRow([
					UI.label(_('Password')),
					this._password = UI.pass(null, {
						'aria-label': 'Password',
						'data-required': _('Password is required'),
						'data-validate': 'required password'
					}),
					UI.div('flex items-center gap-2', [
						this._showPass = UI.chk(null, null, {
							'class': 'h-4 w-4',
							'id': 'showCirclePass'
						}),
						UI.htm('label', 'text-sm cursor-pointer', _('Show password'), null, {
							'for': 'showCirclePass'
						})
					])
				]),
				UI.formRow([
					UI.div(
						'flex justify-between',
						[
							UI.toggle(
								this._newCircleProtected = UI.chk(),
								UI.span('', _('Protected circle')),
								{
									'data-tip': 'above',
									'aria-label': _('Protected circles provide extra support for those who need it. <br/> Required for under 16\'s <br/> You will be a circle guardian')
								}
							)
						]
					)
				]),
			]);
			this._newUserDetails.onSubmit = ev => {ev.preventDefault(); return false;}
			onEv(this._showPass, 'change', () => {
				this._password.type = this._showPass.checked ? 'text' : 'password';
			});
			this.validation = new Validate(this._newUserDetails);
		}
		this._newCircleProtected.checked = true;
		this.validation.primeButton(this.newDialog.affirmButton);
		return this._newUserDetails;
	}

	get newType() {
		for (let el of document.getElementsByName('new-member-type')) {
			if (el.checked) this._newCircleType = el.value;
		}
		return this._newCircleType;
	}
	
	back() {
		if (this._route.length > 1) this._route.shift();
		this.updateNewForm();
	}

	// all logic for deciding the next dialog should go in this function
	next() {
		let next = this.nextForm();
		if (next) {
			this._route.unshift(next);
			this.updateNewForm();
		}
		else {
			this.saveNewCircle();
		}
	}

	nextForm() {
		switch (this._route[0]) {
			case 'selectType':
				if (this.newType == 1) {
					return 'ownPlan';
				}
				else if (this.newType == 2) {
					return 'centerDetails';
				}
			case 'centerDetails':
				this.validation.releaseButton();
				if (this._newCircleProtected.checked) {
					return 'centerPermissions';
				}
				return 'otherPlan';
			case 'centerPermissions':
				return 'otherPlan';
		}
		return false;
	}

	updateNewForm() {
		this.newCircleBackBtn.disabled = this._route.length < 2;
		this.newDialog.clear();
		this._newDialog.affirmButton.disabled = true;
		if (this._route.length) switch (this._route[0]) {
			case 'selectType':
				this.newDialog.affirmLabel = _('NEXT');
				this.newDialog.body = this.newTypeForm;
				break;
			case 'centerDetails':
				this.newDialog.affirmLabel = _('NEXT');
				this.showUserDetails();
				break;
			case 'centerPermissions':
				this.newDialog.affirmLabel = _('NEXT');
				this.showNewUserPermissions();
				this.newDialog.affirmButton.disabled = false;
				break;
			case 'ownPlan':
				this.newDialog.affirmLabel = _('CREATE CIRCLE');
				this.showOwnPlan();
				break;
			case 'otherPlan':
				this.newDialog.affirmLabel = _('CREATE CIRCLE');
				this.showOtherPlan();
				break;
		}
	}

	showOwnPlan() {
		let result = UI.form();
		// Circle is for this user
		if (this._plan.status == 0) {
			// Trial available
			result.appendChild(UI.formRow(
				UI.label([
					UI.input('radio', 'm-3', 'individualTrial', {
						'change': () => this.newDialog.affirmButton.disabled = false
					}, { 'name': 'newCirclePlan' }),
					UI.span('', 'Start your circle on individual trial plan.')
				])
			));
			result.appendChild(UI.formRow(
				UI.label([
					UI.input('radio', 'm-3', 'familyTrial', {
						'change': () => this.newDialog.affirmButton.disabled = false
					}, {'name': 'newCirclePlan'}),
					UI.span('', 'Start your circle on a family trial plan.')
				])
			));
			result.append(UI.p('', 'This option is best if you plan to create and look after more than one circle'));
		}
		else if (this._plan.type == 2 && this._plan.members.length < 5) {
			// Family account with space
			result.appendChild(UI.p('', 'As you have an active family plan, your circle will be added to that plan'));
			this.newDialog.affirmButton.disabled = false;
		}
		else if (this._plan.type == 2 && this._plan.members.length == 5) {
			result.appendChild(UI.p('', "Your circle can't be created at this time. You have a full family plan. To create your own circle you must first make space on your plan."));
			result.appendChild(UI.p('', 'Click here to see a video showing how to do this.'));
		}
		else {
			// Must goto account page and reset plan
			result.appendChild(UI.p('', "Your circle can't be created at this time."));
			result.appendChild(UI.p('', "Your trial period has previously been used."));
			result.appendChild(UI.p('', 'Please go to your account page and re-start your plan there.'));
		}
		this.newDialog.body = result;
	}

	showOtherPlan() {
		let result = UI.form(UI.formRow(
			UI.label([
				UI.input('radio', 'm-3', 'individualTrial', {
					'change': () => this.newDialog.affirmButton.disabled = false
				}, { 'name': 'newCirclePlan' }),
				UI.span('', 'Start the circle on a individual trial plan')
			])
		));
		// Circle is for another user
		// Starting an individual trial is always an option
		if (this._plan.status == Account.NEW) {
			// Start a new family trial plan
			result.appendChild(UI.formRow(
				UI.label([
					UI.input('radio', 'm-3', 'familyTrial', {
						'change': () => this.newDialog.affirmButton.disabled = false
					}, {'name':'newCirclePlan'}),
					UI.span('','Start a new family plan in your account and add the new circle')
				])
			));
			result.appendChild(UI.p('', 'This is a good option if you plan to create and manage more than one circle'));
		}
		if (this._plan.status < Account.PAUSED && this._plan.type == 2 && this._plan.members.length < 5) {
			// Add to the active family plan
			result.appendChild(UI.formRow(
				UI.label([
					UI.input('radio', 'm-3', 'activeFamily', {
						'change': () => this.newDialog.affirmButton.disabled = false
					}, {'name':'newCirclePlan'}),
					UI.span('', 'Start the circle and add to your existing family plan')
				])
			));
		}
		if (this._plan.type == 1 && this._plan.status == Account.TRIAL) {
			result.appendChild(UI.formRow(
				UI.label([
					UI.input('radio', 'm-3', 'upgradeTrial', {
						'change': () => this.newDialog.affirmButton.disabled = false
					}, {'name':'newCirclePlan'}),
					UI.span('', 'Change your individual trial plan to family and add the circle to that plan')
				])
			));
			result.appendChild(UI.p('', 'This is the best option if you intend to pay for this circle going forward'))
		}
		if (this._plan.status == Account.SUSPENDED) {
			// Reenable dormant plan as family and add this circle (best if planning to support more than one circle)
			result.appendChild(UI.p('',"Your own plan is dormant, if you wish to support more than one circle with a family plan you will need to re-start your plan from your account page. Here a video showing how to do that."));
		}
		if (this._plan.type == 1 && this._plan.status > Account.TRIAL && this._plan.status < Account.PAUSED) {
			// Change individual plan to family and add to that
			result.appendChild(UI.p('',"Your own circle is on an individual plan, if you wish to support more than one circle with a family plan you will need to change your plan from your account page. Here a video showing how to do that."));
		}
		this.newDialog.body = result;
	}

	get newCirclePlan() {
		for (let el of document.getElementsByName('newCirclePlan')) {
			if (el.checked) return el.value;
		}
		return '';
	}

	getCircle(id) {
		for (let c of this.circles) {
			if (c.id == id) return c;
		}
		return null;
	}

	setNewType() {
		this.newDialog.affirmButton.disabled = this.newType == 0;
	}

	showUserDetails() {
		this._newDialog.body = this.newUserDetails;
		this._fullName.select();
	}

	showNewUserPermissions() {
		this._newDialog.body = UI.div(
			'p-4', 
			this._newUserPermission.form
		);
	}

	saveNewCircle() {
		API.insert('circles', {
			'forMe': this.newType == 1 ? 1 : 0,
			'fullName': this.newType == 1 ? '' : this._fullName.value,
			'username': this.newType == 1 ? '' : this._username.value,
			'email': this.newType == 1 ? '' : this._email.value,
			'password': this.newType == 1 ? '' : this._password.value,
			'protected': (this.newType != 1 && this._newCircleProtected.checked) ? 1 : 0,
			'permission': this.newType == 1 ? null : this._newUserPermission.value,
			'plan': this.newCirclePlan
		})
		.then(reply => {
			if (showError(reply)) return;
			window.location.replace('/members?circle='+reply.id);
		});
		if (this._newUserDetails) {
			delete this._newUserDetails;
			delete this._newUserPermission;
		}
	}

	add(circle) {
		if(circle.own) {
			this.circles.unshift(circle);
		}
		else {
			this.circles.push(circle);
		}
	}

	pickerRows() {
		const rows = [
			UI.div('flex w-full items-center px-3 py-1 text-xs font-semibold text-zinc-500', [
				UI.span('flex-1', _('Circles')),
				!this.nav.userPermissions.isProtected
					? UI.secIconBtn('plus-square', 20, {
						'click': _ => {
							this._newCircleType = 0;
							this.newDialog.open();
							this._route = activeCircle ? ['centerDetails'] : ['selectType'];
							this.updateNewForm();
						}
					})
					: null
			])
		];
		for (const circle of this.circles) {
			rows.push(UI.popupItem(
				[
					UI.span('flex-none px-3', UI.icon('circle', 20)),
					UI.span('flex-1 px-3', circle.name)
				],
				{ 'click': () => this.nav.selectUnit(Nav.CIRCLE, circle.id) }
			));
		}
		const guardianships = this.circles.filter(c => !c.own && c.isGuardian);
		if (guardianships.length > 0) {
			rows.push(UI.div('flex w-full items-center px-3 py-1 text-xs font-semibold text-zinc-500', [
				UI.span('flex-1', _('Guardianships'))
			]));
			for (const circle of guardianships) {
				rows.push(UI.popupItem(
					[
						UI.span('flex-none px-3', UI.icon('shield', 20)),
						UI.span('flex-1 px-3', circle.ownerName)
					],
					{ 'click': () => this.nav.selectUnit(Nav.GUARDIANSHIP, circle.id) }
				));
			}
		}
		return rows;
	}
}

class Circle {
	static myCircle() {
		let inst = new Circle();
		inst.name = _('My Circle');
		return inst;
	}

	static fromData(data) {
		let inst = new Circle();
		inst.circle_id = data.unit_id;
		inst.name = data.own ? _('My Circle') : `${data.unit_name}`;
		inst.memberPermission = new MemberPermission(null, data.member_permission, Nav.CIRCLE);
		inst.own = data.own;
		inst.center = data.parent_id;
		inst.ownerPermissions = new Permissions(data.unit_id);
		inst.ownerName = data.first_name + ' ' + data.last_name;
		inst.params = new URLSearchParams(`circle=${inst.circle_id}`);
		inst.centerParams = new URLSearchParams(`center=${inst.center}`);
		return inst;
	}

	constructor() {
		this.circle_id = null;
		this.name = null;
		

		this.active = false;
		this.memberPermission = null;
	}

	get id() {
		return this.circle_id;
	}

	get isGuardian() {
		return this.memberCan(MemberPermission.GUARDIAN);
	}
	
	get isAdmin() {
		return this.memberCan(MemberPermission.ADMIN);
	}

	memberCan(perm) {
		return this.memberPermission.can(perm);
	}

	centerUrlForPage(page) {
		if (this.own || !this.memberCan(MemberPermission.GUARDIAN)) return null;
		const guardianPages = ['layers', 'resources', 'graphics', 'spaces', 'account', 'devices'];
		return guardianPages.includes(page) ? `/${page}?${this.centerParams}` : null;
	}

	urlForPage(page) {
		switch (page) {
			case 'timeline':
				return (this.memberCan(MemberPermission.VIEW_ACTIVITIES) ||
				        this.memberCan(MemberPermission.VIEW_FEELINGS) ||
				        this.memberCan(MemberPermission.VIEW_PINS))
					? `/timeline?${this.params}` : null;
			case 'resources':
				return this.memberCan(MemberPermission.VIEW_RESOURCES) ? `/resources?${this.params}` : null;
			case 'graphics':
				return this.memberCan(MemberPermission.VIEW_GRAPHICS) ? `/graphics?${this.params}` : null;
			case 'emotions':
				return this.memberCan(MemberPermission.ADMIN) ? `/emotions?${this.params}` : null;
			case 'pins':
				return this.memberCan(MemberPermission.ADMIN) ? `/pins?${this.params}` : null;
			case 'members':
				return `/members?${this.params}`;
			default:
				return null;
		}
	}

	getNavLinks() {
		const links = [
			(this.memberCan(MemberPermission.VIEW_ACTIVITIES) ||
			 this.memberCan(MemberPermission.VIEW_FEELINGS) ||
			 this.memberCan(MemberPermission.VIEW_PINS))
				? Nav.linkRow('timeline', _('Timeline'), `/timeline?${this.params}`) : null,
			this.memberCan(MemberPermission.VIEW_RESOURCES)
				? Nav.linkRow('resources', _('Resources'), `/resources?${this.params}`) : null,
			this.memberCan(MemberPermission.VIEW_GRAPHICS)
				? Nav.linkRow('graphics', _('Graphics'), `/graphics?${this.params}`) : null,
			this.memberCan(MemberPermission.ADMIN)
				? Nav.linkRow('emotions', _('Emotions'), `/emotions?${this.params}`) : null,
			this.memberCan(MemberPermission.ADMIN)
				? Nav.linkRow('pin', _('Pins'), `/pins?${this.params}`) : null,
			Nav.linkRow('members', _('Members'), `/members?${this.params}`)
		];
		return links;
	}

	getGuardianNavLinks() {
		return [
			Nav.linkRow('layers', _('Layers'), `/layers?${this.centerParams}`),
			Nav.linkRow('resources', _('Resources'), `/resources?${this.centerParams}`),
			Nav.linkRow('graphics', _('Graphics'), `/graphics?${this.centerParams}`),
			Nav.linkRow('globe-stand', _('Spaces'), `/spaces?${this.centerParams}`),
			Nav.linkRow('user-cog', _('Account'), `/account?${this.centerParams}`),
			Nav.linkRow('mobile', _('Devices'), `/devices?${this.centerParams}`),
			Nav.clickRow('shield', _('Permissions'), () => this.ownerPermissions.open())
		];
	}

}